var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19 19",
    style: {
      enableBackground: "new 0 0 19 19"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3048",
    className: "st0",
    d: "M1.5,1.5v5.8h5.8V1.5H1.5z M1.5,0h5.8c0.8,0,1.5,0.7,1.5,1.5v5.8c0,0.8-0.7,1.5-1.5,1.5H1.5 C0.7,8.8,0,8.1,0,7.3V1.5C0,0.7,0.7,0,1.5,0L1.5,0L1.5,0z M1.5,11.7v5.8h5.8v-5.8H1.5z M1.5,10.2h5.8c0.8,0,1.5,0.7,1.5,1.5v5.8 c0,0.8-0.7,1.5-1.5,1.5H1.5C0.7,19,0,18.3,0,17.5v-5.8C0,10.9,0.7,10.2,1.5,10.2L1.5,10.2z M14.6,1.5c-1.6,0-2.9,1.3-2.9,2.9 s1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9l0,0C17.5,2.8,16.2,1.5,14.6,1.5L14.6,1.5z M14.6,0C17,0,19,2,19,4.4s-2,4.4-4.4,4.4 s-4.4-2-4.4-4.4l0,0C10.2,2,12.2,0,14.6,0L14.6,0z M11.7,11.7v5.8h5.8v-5.8H11.7z M11.7,10.2h5.8c0.8,0,1.5,0.7,1.5,1.5v5.8 c0,0.8-0.7,1.5-1.5,1.5h-5.8c-0.8,0-1.5-0.7-1.5-1.5v-5.8C10.2,10.9,10.9,10.2,11.7,10.2L11.7,10.2z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllWhite);
export default __webpack_public_path__ + "static/media/all_white.bffd912e3e1cc68d310fa25095ca582e.svg";
export { ForwardRef as ReactComponent };